import axios from "axios";
import authHeader from './utils/auth-header';

const API_URL = '/OppPortal/api/v1/portals/';

class ClientDataService {
    countAll() {
        return axios.get(API_URL + "count/clients", {headers: authHeader()});
    }

    getAll() {
        return axios.get(API_URL + "clients", {headers: authHeader()});
    }

    get(id) {
        return axios.get(API_URL + `clients/${id}`, {headers: authHeader()});
    }

    create(data) {
        return axios.post(API_URL + "clients", data, {headers: authHeader()});
    }

    update(id, data, changePassword, changeLsPassword) {
        return axios.put(API_URL + `clients/${id}?changePassword=${changePassword}&changeLsPassword=${changeLsPassword}`, data, {headers: authHeader()});
    }

    delete(id) {
        return axios.delete(API_URL + `clients/${id}`, {headers: authHeader()});
    }

    findByName(name) {
        return axios.get(API_URL + `clients?name=${name}`, {headers: authHeader()});
    }

    testConnection(id) {
        return axios.get(API_URL + `clients/${id}/connection`, {headers: authHeader()});
    }

    findValues(id, linkedClass) {
        return axios.get(API_URL + `clients/${id}/values/${linkedClass}`, {headers: authHeader()});
    }

    findContactGroups(id) {
        return axios.get(API_URL + `clients/${id}/contactgroups`, {headers: authHeader()});
    }
}

export default new ClientDataService();